import { createReducer, on } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { Counters, DashCounters } from '@apps/auth/domain/models/back/dash-counters';
import { BackAuthCountersLoaded } from '@apps/back/store/auth/auth.actions';
import { BackConstants, InternalStatus } from '@apps/back/back.constants';
import { User } from '@apps/auth/domain/models/back';

import * as fromBackAuthUsersInternal from './users-internal.actions';
import { IUsersState, updateUserActiveStatus, usersAdapter, usersInitialState } from '../users.common';
import { ODataAuth } from '../../ODataAuth';
import { StatusesMetadata } from '@common/models';

export const BackAuthUsersInternalFeatureKey = 'internal';

export interface IBackAuthUsersInternalState extends StatusesMetadata
{
    counters: Counters;
    oData: ODataAuth;
    users: IUsersState;
    qsWord: string;
    qsWordImpe: string;
}

export const BackAuthUsersInternalInitialState: IBackAuthUsersInternalState =
{
    counters: new Counters(),
    oData: new ODataAuth(BackConstants.QSUsersTop, InternalStatus),
    users: usersInitialState,
    qsWord: '',
    qsWordImpe: '',
    ...StatusesMetadata.init()
};

export const BackAuthUsersInternalReducer = createReducer(
    BackAuthUsersInternalInitialState,
    on(
        BackAuthCountersLoaded,
        (state: IBackAuthUsersInternalState, { usersCounters }: { entitiesCounters: DashCounters, usersCounters: DashCounters }) => ({
            ...state,
            counters: usersCounters.internal
        })
    ),
    on(
        fromBackAuthUsersInternal.BackAuthUsersInternalODataRequested,
        (state: IBackAuthUsersInternalState) => ({
            ...state,
            ...StatusesMetadata.requested()
        })
    ),
    on(
        fromBackAuthUsersInternal.BackAuthUsersInternalODataLoaded,
        (state: IBackAuthUsersInternalState, { users }: {users: User[]}) => ({
            ...state,
            users: usersAdapter.setAll(users, state.users),
            ...StatusesMetadata.succeeded(users && users.length !== 0, users && users.length === 0)
        })
    ),
    on(
        fromBackAuthUsersInternal.BackAuthUsersInternalODataFailed,
        (state: IBackAuthUsersInternalState) => ({
            ...state,
            ...StatusesMetadata.failed()
        })
    ),
    on(
        fromBackAuthUsersInternal.BackAuthUsersInternalIdentityUpdated,
        (state: IBackAuthUsersInternalState, { user }: {user: Update<User>}) => ({
            ...state,
            users: usersAdapter.updateOne(user, state.users),
        })
    ),
    on(
        fromBackAuthUsersInternal.BackAuthUsersInternalQsWordSet,
        (state, { qsWord }: { qsWord: string; }) =>
            ({
                ...state,
                qsWord: qsWord.toLowerCase()
            })
    ),
    on(
        fromBackAuthUsersInternal.BackAuthInternalUserHabsUpdated,
        (state: IBackAuthUsersInternalState, { user }: { user: Update<User> }) =>
            ({
                ...state,
                users: usersAdapter.updateOne(user, state.users),
            })
    ),
    on(
        fromBackAuthUsersInternal.BackAuthUsersInternalUserActiveStatusUpdated,
        (state: IBackAuthUsersInternalState, { userId, active }: { userId: string; active: boolean }) => ({
            ...state,
            users: updateUserActiveStatus(state.users, userId, active)
        })
    )
);
